Object.defineProperty(exports, '__esModule', {
  value: true
});
var React = require('react');
var pluralize = require('pluralize');
var lab = require('@material-ui/lab');
var core = require('@material-ui/core');
var frontend = require('@ds-developer/frontend');
var reactFeather = require('react-feather');
var MapLink = require('@ds-developer/map-link');
var PortletTitle = require('@ds-developer/portlet-title');
var reactRouterDom = require('react-router-dom');
var RejectLearnerModal = require('@ds-developer/reject-learner-modal');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var pluralize__default = /*#__PURE__*/_interopDefaultLegacy(pluralize);
var MapLink__default = /*#__PURE__*/_interopDefaultLegacy(MapLink);
var PortletTitle__default = /*#__PURE__*/_interopDefaultLegacy(PortletTitle);
var RejectLearnerModal__default = /*#__PURE__*/_interopDefaultLegacy(RejectLearnerModal);
var useStyles = core.makeStyles(function (theme) {
  var _a;
  return {
    mapLink: {
      margin: theme.spacing(0, 0, 0, 6)
    },
    button: (_a = {}, _a[theme.breakpoints.up("md")] = {
      display: "flex",
      justifyContent: "flex-end"
    }, _a),
    viewLearnerLink: {
      color: theme.palette.primary.main,
      textDecoration: "none",
      "&:hover": {
        textDecoration: "underline"
      }
    }
  };
});
var PendingLearnerListItem = function PendingLearnerListItem(_a) {
  var id = _a.id,
    fullName = _a.fullName,
    postcode = _a.postcode,
    address = _a.address,
    firstLesson = _a.firstLesson,
    isShortNoticeTest = _a.isShortNoticeTest,
    learnerLessonType = _a.learnerLessonType,
    setRejectLearnerModalOpen = _a.setRejectLearnerModalOpen,
    trackEvent = _a.trackEvent;
  var classes = useStyles();
  var handleRejectClick = function handleRejectClick() {
    if (trackEvent) {
      trackEvent({
        eventCategory: "Learner",
        eventAction: "Button Click",
        eventLabel: "Reject"
      });
    }
    setRejectLearnerModalOpen(true, id);
  };
  var trackOpenMapLink = function trackOpenMapLink() {
    if (trackEvent) {
      trackEvent({
        eventCategory: "Learner",
        eventAction: "Interaction",
        eventLabel: "Map"
      });
    }
  };
  var firstLessonDate = firstLesson ? new Date(firstLesson.startDateTime).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "numeric",
    year: "numeric"
  }) : null;
  var firstLessonTime = firstLesson ? new Date(firstLesson.startDateTime).toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit"
  }) + " - " + new Date(firstLesson.endDateTime).toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit"
  }) : null;
  return React__default['default'].createElement(React.Fragment, null, React__default['default'].createElement(core.Divider, null), React__default['default'].createElement(core.Box, {
    key: id,
    marginY: 3,
    marginX: 2,
    "data-test": "pending-learner"
  }, React__default['default'].createElement(core.Grid, {
    container: true,
    spacing: 3,
    justify: "space-between"
  }, React__default['default'].createElement(core.Grid, {
    item: true,
    xs: 12,
    sm: 12,
    md: 3
  }, React__default['default'].createElement(PortletTitle__default['default'], {
    title: "learner name"
  }, React__default['default'].createElement(core.Typography, {
    variant: "h2",
    component: "span",
    color: "textPrimary"
  }, fullName)), React__default['default'].createElement(core.Box, {
    marginTop: "4px"
  }, React__default['default'].createElement(reactRouterDom.Link, {
    to: "/learners/" + id,
    className: classes.viewLearnerLink
  }, "View learner"))), React__default['default'].createElement(core.Grid, {
    item: true,
    xs: 12,
    sm: 12,
    md: 2
  }, React__default['default'].createElement(core.Box, null, React__default['default'].createElement(PortletTitle__default['default'], {
    title: "type"
  }, React__default['default'].createElement(core.Typography, {
    variant: "body1",
    color: "textPrimary"
  }, "" + (isShortNoticeTest ? " SNT learner" : learnerLessonType))))), React__default['default'].createElement(core.Grid, {
    item: true,
    xs: 12,
    sm: 12,
    md: 2
  }, firstLesson && React__default['default'].createElement(PortletTitle__default['default'], {
    title: "First lesson"
  }, React__default['default'].createElement(core.Typography, {
    variant: "body1",
    color: "textPrimary"
  }, firstLessonDate), React__default['default'].createElement(core.Typography, {
    variant: "body1",
    color: "textPrimary"
  }, firstLessonTime))), React__default['default'].createElement(core.Grid, {
    item: true,
    xs: 12,
    sm: 12,
    md: 2
  }, React__default['default'].createElement(PortletTitle__default['default'], {
    title: "Pick Up"
  }, React__default['default'].createElement(core.Typography, {
    variant: "body1",
    color: "textPrimary"
  }, address)), React__default['default'].createElement(core.Box, {
    display: "flex",
    alignItems: "flex-end"
  }, React__default['default'].createElement(core.Typography, {
    variant: "body1",
    color: "textPrimary"
  }, postcode), React__default['default'].createElement(core.Box, {
    className: classes.mapLink
  }, React__default['default'].createElement(MapLink__default['default'], {
    postcode: postcode,
    onClick: trackOpenMapLink
  })))), React__default['default'].createElement(core.Grid, {
    item: true,
    xs: 12,
    sm: 12,
    md: "auto",
    className: classes.button,
    alignItems: "baseline"
  }, React__default['default'].createElement(core.Button, {
    "data-test": "reject-learner-modal-open-button",
    variant: "outlined",
    startIcon: React__default['default'].createElement(reactFeather.Trash2, {
      size: 14
    }),
    onClick: handleRejectClick
  }, "Reject")))));
};
var useStyles$1 = core.makeStyles(function (theme) {
  var _a;
  return {
    updateTime: (_a = {
      margin: theme.spacing(1.25, 1.5, 0, 0)
    }, _a[theme.breakpoints.only("xs")] = {
      maxWidth: "100px",
      textAlign: "right"
    }, _a)
  };
});
var PendingLearners = function PendingLearners(_a) {
  var _b;
  var learners = _a.learners,
    _submit = _a.submit,
    submitting = _a.submitting,
    loadingRejectLearner = _a.loadingRejectLearner,
    rejectLearnerModalOpen = _a.rejectLearnerModalOpen,
    setRejectLearnerModalOpen = _a.setRejectLearnerModalOpen,
    trackEvent = _a.trackEvent;
  var classes = useStyles$1();
  if (!(learners === null || learners === void 0 ? void 0 : learners.length)) return React__default['default'].createElement(React.Fragment, null);
  var numberOfLearners = learners.length;
  var title = "Great news! You have " + numberOfLearners + " " + pluralize__default['default'](" new learner", numberOfLearners) + ".";
  var mostRecentlyCreatedLearner = (_b = learners[0]) === null || _b === void 0 ? void 0 : _b.created;
  var hoursSinceMostRecentlyCreatedLearner = frontend.formatDistance(new Date(mostRecentlyCreatedLearner), new Date(Date.now()), {
    addSuffix: true
  });
  var handleCancelEvent = function handleCancelEvent() {
    if (trackEvent) {
      trackEvent({
        eventCategory: "Learner",
        eventAction: "Button Click",
        eventLabel: "Cancel"
      });
    }
    setRejectLearnerModalOpen(false);
  };
  var handleReasonInputClick = function handleReasonInputClick() {
    if (trackEvent) {
      frontend.fireOnce("Learner|Interaction|Reject Reason", function () {
        trackEvent({
          eventCategory: "Learner",
          eventAction: "Interaction",
          eventLabel: "Reject Reason"
        });
      });
    }
  };
  return React__default['default'].createElement(core.Card, {
    "data-test": "pending-learners-panel"
  }, rejectLearnerModalOpen && React__default['default'].createElement(RejectLearnerModal__default['default'], {
    loading: loadingRejectLearner,
    submitting: submitting,
    submit: function submit(args) {
      return _submit(args);
    },
    handleCancelEvent: handleCancelEvent,
    handleReasonInputClick: handleReasonInputClick
  }), React__default['default'].createElement(core.CardHeader, {
    title: title,
    action: React__default['default'].createElement(core.Box, {
      className: classes.updateTime
    }, hoursSinceMostRecentlyCreatedLearner)
  }), learners.map(function (_a) {
    var id = _a.id,
      fullName = _a.fullName,
      postcode = _a.postcode,
      isShortNoticeTest = _a.isShortNoticeTest,
      learnerLessonType = _a.learnerLessonType,
      address = _a.address,
      firstLesson = _a.firstLesson;
    return React__default['default'].createElement(PendingLearnerListItem, {
      key: id,
      id: id,
      fullName: fullName,
      postcode: postcode,
      address: address,
      firstLesson: firstLesson,
      learnerLessonType: learnerLessonType,
      isShortNoticeTest: isShortNoticeTest,
      loadingRejectLearner: loadingRejectLearner,
      setRejectLearnerModalOpen: setRejectLearnerModalOpen,
      trackEvent: trackEvent
    });
  }), React__default['default'].createElement(lab.Alert, {
    variant: "filled",
    severity: "success",
    "data-test": "pending-learners-panel-snackbar"
  }, "You don't have to do anything to accept " + (numberOfLearners > 1 ? "these learners" : "this learner") + ". It's now automatic."));
};
exports.default = PendingLearners;